import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <div className="bg-white shadow-md rounded-lg p-6">
        <p className="mb-4">Last updated: November 18, 2025</p>

        <p className="mb-4">
          RE-loop ("us", "we", or "our") operates the RE-loop website (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
        </p>

        <h2 className="text-2xl font-bold mb-4">Information Collection and Use</h2>
        <p className="mb-4">
          We collect several different types of information for various purposes to provide and improve our Service to you.
        </p>

        <h3 className="text-xl font-bold mb-2">Types of Data Collected</h3>
        <ul className="list-disc list-inside mb-4">
          <li>Personal Information: Name, email address, phone number, shipping address.</li>
          <li>Transactional Information: Details of products you buy and sell.</li>
          <li>Usage Data: Information on how you use the website.</li>
        </ul>

        <h2 className="text-2xl font-bold mb-4">Use of Data</h2>
        <p className="mb-4">
          RE-loop uses the collected data for various purposes:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>To provide and maintain our Service</li>
          <li>To notify you about changes to our Service</li>
          <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
          <li>To provide customer support</li>
          <li>To gather analysis or valuable information so that we can improve our Service</li>
          <li>To monitor the usage of our Service</li>
          <li>To detect, prevent and address technical issues</li>
        </ul>

        <h2 className="text-2xl font-bold mb-4">Sharing of Data</h2>
        <p className="mb-4">
          We may share your personal information with third-party vendors for purposes such as payment processing, shipping, and marketing. We will not sell your personal information to third parties.
        </p>

        <h2 className="text-2xl font-bold mb-4">Data Security</h2>
        <p className="mb-4">
          The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
        </p>

        <h2 className="text-2xl font-bold mb-4">Your Rights</h2>
        <p className="mb-4">
          You have the right to access, update, or delete your personal information at any time by accessing your account settings.
        </p>

        <h2 className="text-2xl font-bold mb-4">Changes to This Privacy Policy</h2>
        <p className="mb-4">
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </p>

        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at support@re-loop.com.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
